// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2tsJj","label":"Radio_label__HvIDp","checkMark":"Radio_checkMark__1bs3z","disabled":"Radio_disabled__7Xjq1"};